module.exports = __webpack_public_path__ + "static/media/variable-bubble.5b40ae57.svg";